import { useEffect, useState } from "react";
import { db } from "./firebase";
import { collection, getDocs } from "firebase/firestore";
import "./App.css";

function PokemonResults() {
  const [decks, setDecks] = useState([]);
  const [selectedDeck, setSelectedDeck] = useState(null);
  const [sortConfig, setSortConfig] = useState(null);

  const pokemonIcons = {
    "Gardevoir": "https://r2.limitlesstcg.net/pokemon/gen9/gardevoir.png",
    "Conkeldurr": "https://r2.limitlesstcg.net/pokemon/gen9/conkeldurr.png",
    "Ceruledge": "https://r2.limitlesstcg.net/pokemon/gen9/ceruledge.png",
    "Eevee Tera Box": "https://r2.limitlesstcg.net/pokemon/gen9/sylveon.png",
    "Tera Moon": "https://r2.limitlesstcg.net/pokemon/gen9/roaring-moon.png",
    "Mamoswine": "https://r2.limitlesstcg.net/pokemon/gen9/mamoswine.png",
    "Dragapult": "https://r2.limitlesstcg.net/pokemon/gen9/dragapult.png",
    "Dragapult-Charizard": "https://r2.limitlesstcg.net/pokemon/gen9/dragapult.png",
    "N's Zoroark": "https://r2.limitlesstcg.net/pokemon/gen9/zoroark.png",
    "Grimmsnarl-Froslass": "https://r2.limitlesstcg.net/pokemon/gen9/grimmsnarl.png",
    "Raging Bolt": "https://r2.limitlesstcg.net/pokemon/gen9/raging-bolt.png",
    "Slaking": "https://r2.limitlesstcg.net/pokemon/gen9/slaking.png",
    "Gholdengo": "https://r2.limitlesstcg.net/pokemon/gen9/gholdengo.png",
    "Hop's Zacian": "https://r2.limitlesstcg.net/pokemon/gen9/zacian.png",
    "Slowking": "https://r2.limitlesstcg.net/pokemon/gen9/slowking.png",
    "Roaring Moon": "https://r2.limitlesstcg.net/pokemon/gen9/roaring-moon.png",
    "Arboliva-Froslass": "https://r2.limitlesstcg.net/pokemon/gen9/arboliva.png",
    "Armarouge Box": "https://r2.limitlesstcg.net/pokemon/gen9/armarouge.png",
    "Okidogi Scizor": "https://r2.limitlesstcg.net/pokemon/gen9/okidogi.png",
    "Yanmega": "https://r2.limitlesstcg.net/pokemon/gen9/yanmega.png",
    "Joltik Box": "https://r2.limitlesstcg.net/pokemon/gen9/joltik.png",
    "Gholdengo-Joltik Box": "https://r2.limitlesstcg.net/pokemon/gen9/gholdengo.png",
    "Ethan's Typhlosion": "https://r2.limitlesstcg.net/pokemon/gen9/typhlosion.png",
    "Ancient Box": "https://r2.limitlesstcg.net/pokemon/gen9/roaring-moon.png",
    "Tera Box": "https://r2.limitlesstcg.net/pokemon/gen9/ogerpon.png",
    "Kangaskhan Tera Box": "https://r2.limitlesstcg.net/pokemon/gen9/kangaskhan.png",
    "Hydrapple-Meganium": "https://r2.limitlesstcg.net/pokemon/gen9/hydrapple.png",
    "Absol Box": "https://r2.limitlesstcg.net/pokemon/gen9/absol.png",
    "Seaking Festival Lead": "https://r2.limitlesstcg.net/pokemon/gen9/seaking.png",
    "Alakazam-Dudunsparce": "https://r2.limitlesstcg.net/pokemon/gen9/alakazam.png",
    "Mega Latias Box": "https://r2.limitlesstcg.net/pokemon/gen9/latias-mega.png",
    "Charizard":"https://r2.limitlesstcg.net/pokemon/gen9/charizard.png",
    "Mega Sharpedo": "https://r2.limitlesstcg.net/pokemon/gen9/sharpedo-mega.png",
    "Mega Lopunny-Dusknoir": "https://r2.limitlesstcg.net/pokemon/gen9/lopunny-mega.png",
    "Pidgeot Tera Box": "https://r2.limitlesstcg.net/pokemon/gen9/pidgeot.png",
    "Mega Absol Box": "https://r2.limitlesstcg.net/pokemon/gen9/absol-mega.png",
    "Okidogi": "https://r2.limitlesstcg.net/pokemon/gen9/okidogi.png",
    "Mega Hawlucha-Lucario": "https://r2.limitlesstcg.net/pokemon/gen9/hawlucha-mega.png",
    "Salazzle": "https://r2.limitlesstcg.net/pokemon/gen9/salazzle.png",
    "Starmie-Froslass": "https://r2.limitlesstcg.net/pokemon/gen9/starmie.png",
    "Metagross-Empoleon": "https://r2.limitlesstcg.net/pokemon/gen9/metagross.png",
    // Add more leader-icon mappings here
  };

  useEffect(() => {
    const fetchData = async () => {
      const querySnapshot = await getDocs(collection(db, "pokemon_decks"));
      const allDecks = [];

      const parseDate = (str) => {
        const [day, month, year] = str.split(".");
        return new Date(Date.UTC(year, month - 1, day));
      };

      querySnapshot.forEach((doc) => {
        const data = doc.data();
        allDecks.push({
          player: data.Oyuncu,
          deckName: data.Deste,
          decklistUrl: data.decklistUrl,
          placement: data.Sıralama,
          tournamentDate: data.Tarih,
          tournamentDateParsed: parseDate(data.Tarih),
          participants: data.Katılımcı,
          format: data.format,
          organizer: data.organizer,
        });
      });

      allDecks.sort((a, b) => {
        if (a.tournamentDateParsed > b.tournamentDateParsed) return -1;
        if (a.tournamentDateParsed < b.tournamentDateParsed) return 1;
        return a.placement - b.placement;
      });

      setDecks(allDecks);
    };

    fetchData();
  }, []);

const sortBy = (key) => {
  let direction = "ascending";
  if (sortConfig && sortConfig.key === key && sortConfig.direction === "ascending") {
    direction = "descending";
  }

  const sortedData = [...decks].sort((a, b) => {
    let aValue = a[key];
    let bValue = b[key];

    // Use pre-parsed date if sorting by tournamentDate
    if (key === "tournamentDate") {
      aValue = a.tournamentDateParsed;
      bValue = b.tournamentDateParsed;
    }

    if (aValue < bValue) return direction === "ascending" ? -1 : 1;
    if (aValue > bValue) return direction === "ascending" ? 1 : -1;
    return 0;
  });

  setDecks(sortedData);
  setSortConfig({ key, direction });
};


  return (
    <div className="app-container">
      <h1 className="app-title">Türkiye Pokemon TCG Turnuva Sonuçları</h1>

      <table className="deck-table">
        <thead>
          <tr>
            <th onClick={() => sortBy("tournamentDate")}>Tarih</th>
            <th onClick={() => sortBy("deckName")}>Deste</th>
            <th onClick={() => sortBy("player")}>Oyuncu</th>
            <th onClick={() => sortBy("placement")}>Sıralama</th>
            <th onClick={() => sortBy("participants")}>Katılımcı Sayısı</th>
            <th onClick={() => sortBy("format")}>Format</th>
            <th onClick={() => sortBy("organizer")}>Organizatör</th>
          </tr>
        </thead>
        <tbody>
          {decks.map((deck, index) => (
            <tr
              key={index}
              className="deck-row"
              onClick={() => setSelectedDeck(deck)}
            >
              <td>{deck.tournamentDate}</td>
              <td>
                <div className="leader-cell">
                  {pokemonIcons[deck.deckName] && (
                    <img
                      src={pokemonIcons[deck.deckName]}
                      alt={deck.deckName}
                      className="pokemon-icon"
                    />
                  )}
                  <span>{deck.deckName}</span>
                </div>
              </td>
              <td>{deck.player}</td>
              <td>
                <span className={`badge ${deck.placement === 1 ? "gold" : deck.placement === 2 ? "silver" : deck.placement === 3 ? "bronze" : ""}`}>
                  {deck.placement}
                </span>
              </td>
              <td>{deck.participants}</td>
              <td>{deck.format}</td>
              <td>{deck.organizer}</td>
            </tr>
          ))}
        </tbody>
      </table>

      {selectedDeck && (
        <div className="modal-overlay">
          <div className="modal">
            <button
              className="close-button"
              onClick={() => setSelectedDeck(null)}
            >
              ✕
            </button>
            <h2 className="modal-title">
              {selectedDeck.player} – {selectedDeck.deckName}
            </h2>
            <img
              src={selectedDeck.decklistUrl}
              alt="Decklist"
              className="modal-image"
            />
          </div>
        </div>
      )}

      <a href="https://www.instagram.com/pokot.tr/" target="_blank" rel="noopener noreferrer">
        <img src="https://i.ibb.co/HLfdrpYz/logo.png" alt="Pokot Logo" className="bottom-logo" />
      </a>
    </div>
  );
}

export default PokemonResults;
